enum DocumentTypeEnum {
	PrivacyPolicy = 1
}
export default DocumentTypeEnum
